import React, { Component } from 'react';
import classNames from 'classnames';
import Switch from '../Switch/Switch';
import Button from '../Button/Button';
import { ReactComponent as TrashIcon } from '../../../../../icons/dpit-trash-alt-regular.svg';
import { sprintf } from 'sprintf-js';

import './dpit-target-type-box.scss';
import TargetIndicator from '../TargetIndicator/TargetIndicator';


export default class TargetTypeBox extends Component {
	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
		});
		const valueClasses = classNames({
			[`${this.props.classBEMRoot}__value`]: true,
			[`${this.props.classBEMRoot}__value--no-target`]: !this.props.targetSelector,
			[`${this.props.classBEMRoot}__value--skipped`]: this.props.skip === '1',
		});

		const mainRowClasses = classNames({
			[`${this.props.classBEMRoot}__row`]: true,
			[`${this.props.classBEMRoot}__row--center`]: !this.props.targetSelector,
		});

		const buttonClasses = classNames({
			[`${this.props.classBEMRoot}__button--half`]: this.props.onCta2Click,
		});


		const targetButtonIconClass = classNames({
			[`${this.props.classBEMRoot}__button__icon`]: true,
			'dpit-pulse-infinite-light-2s': !this.props.targetSelector
				&& this.props.skip !== '1'
				&& this.props.animateTargetIcon,
		});

		return (
			<div
				className={mainClasses}
				onClick={this.props.onClick
					? this.props.onClick
					: (event) => { event.stopPropagation(); return false; }
				}
				title=""
			>
				{' '}
				<div className={`${this.props.classBEMRoot}__control`}>
					<TargetIndicator
						classBEMRoot="dpit-target-indicator"
						className={classNames({
							[`${this.props.classBEMRoot}__control__icon`]: true,
							[`${this.props.classBEMRoot}__control__item`]: true,
						})}
						inactive={!this.props.targetSelector}
						skip={this.props.skip}
					>
						{this.props.mainIcon}
					</TargetIndicator>
					{this.props.onSkipChange
						? (
							<div title={sprintf(this.props.i18n.skip_or_show, this.props.targetTypeTitle || '')}>
								<Switch
									className={`${this.props.classBEMRoot}__control__skip ${this.props.classBEMRoot}__control__item`}
									options={[{
										displayName: this.props.i18n.SHOW,
										value: '0',
									}, {
										displayName: this.props.i18n.SKIP,
										value: '1',
									}]}
									selectedOption={this.props.skip ? this.props.skip : '0'}
									onSelectOption={this.props.onSkipChange}
								/>
							</div>
						)
						: null
					}
					<div className={`${this.props.classBEMRoot}__control__label ${this.props.classBEMRoot}__control__item`}>
						{this.props.targetTypeTitle ? ` ${this.props.targetTypeTitle}` : ''}
					</div>
				</div>

				<div className={`${this.props.classBEMRoot}__main`}>
					{this.props.mainTitle ? (
						<div className={classNames({
							[`${this.props.classBEMRoot}__title`]: true,
							[`${this.props.classBEMRoot}__title--active`]: this.props.skip !== '1',
						})}
						>
							{this.props.mainTitle}
						</div>
					) : null}
					<div className={mainRowClasses}>
						<Button
							classBEMRoot={`${this.props.classBEMRoot}__button`}
							className={buttonClasses}
							active={this.props.skip !== '1'}
							title={this.props.ctaTitle ? this.props.ctaTitle : this.props.ctaLabel}
							onClick={this.props.onCtaClick}
						>
							{
								this.props.targetIcon
									? <div className={targetButtonIconClass}>{this.props.targetIcon}</div>
									: null
							}
							<div className={`${this.props.classBEMRoot}__button__label`}>
								{' '}
								{this.props.ctaLabel}
								{' '}
							</div>
						</Button>
						{this.props.onCta2Click
							? (
								<Button
									classBEMRoot={`${this.props.classBEMRoot}__button`}
									className={buttonClasses}
									active={this.props.skip !== '1'}
									title={this.props.cta2Title ? this.props.cta2Title : this.props.cta2Label}
									onClick={this.props.onCta2Click}
								>
									{
										this.props.target2Icon
											? <div className={targetButtonIconClass}>{this.props.target2Icon}</div>
											: null
									}
									<div className={`${this.props.classBEMRoot}__button__label`}>{this.props.cta2Label}</div>
								</Button>
							)
							: null}
					</div>
					<div className={`${this.props.classBEMRoot}__row ${this.props.classBEMRoot}__row--middle`}>
						<div className={valueClasses} title={this.props.valueText}>{this.props.valueText}</div>
						<Button
							classBEMRoot={`${this.props.classBEMRoot}__trash`}
							active={this.props.targetSelector && this.props.skip !== '1'}
							title={this.props.i18n.clear_target}
							onClick={this.props.onClearClick}
						>
							<TrashIcon className={`${this.props.classBEMRoot}__control__trash__icon`} />
						</Button>
					</div>
				</div>
			</div>
		);
	}
}
